import './Homepage.scss';

import { DefaultRoutes } from 'Routes';
import { ReactComponent as TeeIcon } from 'icons/TeeIcon.svg';
import { Typography } from '@trackman/web-shared-components';
import { useNavigate } from 'react-router';

export const Homepage = () => {
  const navigate = useNavigate();
  return (
    <div className='Homepage'>
      <div className='Homepage-header header'>
        <Typography component='div' variant='h2'>
          Welcome to Trackman on Course
        </Typography>
        <Typography component='div' variant='body'>
          Select your course
        </Typography>
      </div>
      <div className='Homepage-tiles'>
        <div className='Homepage-tile' onClick={() => navigate(DefaultRoutes.EighteenT, { viewTransition: true })}>
          <TeeIcon />
          <Typography component='div' variant='body' color='white'>
            18T
          </Typography>
        </div>
      </div>
      <div className='Homepage-footer'>
        <Typography component='div' variant='label' onClick={() => navigate(DefaultRoutes.Info, { viewTransition: true })}>
          Info
        </Typography>
      </div>
    </div>
  );
};

export default Homepage;
